import { UserSettings } from '@silbo/core';
import { createContext } from 'react';

type ConfigContextValue = {
  config?: UserSettings;
  isLoading: boolean;
};

export const ConfigContext = createContext<ConfigContextValue>({} as ConfigContextValue);
